import { TableCellPerColumn } from "ds/components/TableSimple/types";

import { ScanResourcesListItem } from "../../../types";
import { SCAN_RESOURCES_COLUMN_ID } from "../constants";
import ScanResourcesTableNameCell from "./NameCell";
import ScanResourcesTableRegionCell from "./RegionCell";
import ScanResourcesTableSettingsCell from "./SettingsCell";
import ScanResourcesTableStatusCell from "./StatusCell";
import ScanResourcesTableTypeCell from "./TypeCell";

const SCAN_RESOURCES_TABLE_CELLS: TableCellPerColumn<ScanResourcesListItem> = {
  [SCAN_RESOURCES_COLUMN_ID.NAME]: ScanResourcesTableNameCell,
  [SCAN_RESOURCES_COLUMN_ID.TYPE]: ScanResourcesTableTypeCell,
  [SCAN_RESOURCES_COLUMN_ID.STATUS]: ScanResourcesTableStatusCell,
  [SCAN_RESOURCES_COLUMN_ID.REGION]: ScanResourcesTableRegionCell,
  [SCAN_RESOURCES_COLUMN_ID.SETTINGS]: ScanResourcesTableSettingsCell,
};

export default SCAN_RESOURCES_TABLE_CELLS;
